import React, { useEffect, useRef, useState } from "react";

/**
 * Continuous horizontal scroller (smooth, seamless loop).
 */

const images = [
    "/pics/image.png",
    "/pics/FB2.png",
    "/pics/FB3.JPG",
    "/pics/FB4.png",
    "/pics/FB5.jpg",
    "/pics/FB6.png",
    "/pics/FB7.png",

];

const Feedback = () => {
    const containerRef = useRef(null);
    const trackRef = useRef(null);
    const posRef = useRef(0);
    const rafRef = useRef(null);
    const lastTimeRef = useRef(null);
    const [isReady, setIsReady] = useState(false);
    const [trackWidth, setTrackWidth] = useState(0);

    const pixelsPerSecond = 100;

    // duplicate images to loop
    const displayImages = [...images, ...images];

    useEffect(() => {
        const handleLoadOrResize = () => {
            if (!trackRef.current) return;
            const total = trackRef.current.scrollWidth;
            setTrackWidth(total / 2);
            setIsReady(true);
        };

        window.addEventListener("resize", handleLoadOrResize);

        const imgs = Array.from(trackRef.current?.querySelectorAll("img") || []);
        let remaining = imgs.length;

        if (imgs.length === 0) handleLoadOrResize();

        imgs.forEach((img) => {
            if (img.complete) {
                remaining--;
            } else {
                img.addEventListener(
                    "load",
                    () => {
                        remaining--;
                        if (remaining <= 0) handleLoadOrResize();
                    },
                    { once: true }
                );
            }
        });

        requestAnimationFrame(handleLoadOrResize);

        return () => window.removeEventListener("resize", handleLoadOrResize);
    }, []);

    useEffect(() => {
        if (!isReady || trackWidth === 0) return;

        const step = (timestamp) => {
            if (!lastTimeRef.current) lastTimeRef.current = timestamp;

            const delta = (timestamp - lastTimeRef.current) / 1000;
            lastTimeRef.current = timestamp;

            posRef.current -= pixelsPerSecond * delta;

            if (Math.abs(posRef.current) >= trackWidth) {
                posRef.current += trackWidth;
            }

            if (trackRef.current) {
                trackRef.current.style.transform = `translateX(${posRef.current}px)`;
            }

            rafRef.current = requestAnimationFrame(step);
        };

        rafRef.current = requestAnimationFrame(step);

        return () => {
            cancelAnimationFrame(rafRef.current);
            lastTimeRef.current = null;
        };
    }, [isReady, trackWidth]);

    return (
        <div
            ref={containerRef}
            className="relative w-full h-[300px] overflow-hidden bg-green-150 mx-auto "
        >
            <div
                ref={trackRef}
                className="flex h-full items-stretch"
                style={{
                    willChange: "transform",
                    transform: `translateX(${posRef.current}px)`,
                }}
            >
                {displayImages.map((src, i) => (
                    <div
                        key={i}
                        className="flex-shrink-0 h-full rounded-3xl  border-gray-200  shadow-sm"
                        style={{
                            width: `${1050 / 3}px`,
                            marginRight: "15px"
                        }}
                    >
                        <img
                            src={src}
                            alt={`slide-${i}`}
                            className="w-full h-full object-cover rounded-2xl"
                            draggable={false}
                        />
                    </div>
                ))}

            </div>
        </div >
    );
};

export default Feedback;
